import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["value", "tdProps", "columnProps"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint implicit-arrow-linebreak: 0 */
/* eslint arrow-parens: 0 */

import { mapProps } from 'recompose';

// Constants
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
var mapCellPropsToRendererProps = function mapCellPropsToRendererProps() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  var value = props.value,
    tdProps = props.tdProps,
    columnProps = props.columnProps,
    restProps = _objectWithoutProperties(props, _excluded);
  var cellColumnProps = columnProps ? _objectSpread(_objectSpread({}, columnProps), columnProps.rest) : EMPTY_OBJECT;
  var cellTdProps = tdProps ? _objectSpread(_objectSpread({}, tdProps), tdProps.rest) : EMPTY_OBJECT;
  var cellProps = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, cellColumnProps), cellTdProps), restProps), {}, {
    data: value
  });
  return cellProps;
};
var makeCellRenderer = function makeCellRenderer(Component) {
  return mapProps(mapCellPropsToRendererProps)(Component);
};
export default makeCellRenderer;